export default function CompletedDocumentAttachmentDirective() {
  return {
    template: require('./completed-document-attachment.html'),
    scope: {
      policyDocumentId: '=',
      canEdit: '=',
      canDelete: '=',
      attachment: '=',
    },
    controller: 'CompletedDocumentAttachmentController',
    controllerAs: 'completedDocumentAttachmentVM',
    bindToController: true,
    replace: true
  };
}
